import React, { useEffect, useRef } from 'react';
import { BaseProps as TooltipBaseProps } from './tooltip';
import { useTooltips } from '@/contexts/tooltip-context';
import { View } from 'react-native';

type Props = Omit<TooltipBaseProps, 'targetRef'> & {
  children?: React.ReactNode;
};

export const TooltipContainer: React.FC<Props> = ({ children, ...rest }) => {
  const ref = useRef<View>(null);
  const { createTooltip, removeTooltip } = useTooltips();

  useEffect(() => {
    createTooltip({
      ...rest,
      targetRef: ref,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rest]);

  useEffect(() => {
    // Remove the tooltip in case this component is unmounted
    return removeTooltip;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const childElement = React.Children.only(children);

  // @ts-ignore
  return React.cloneElement(childElement!, { ref });
};
